type GetNameProps = {
  firstName?: string;
  lastName?: string;
  middleName?: string;
};

export const getName = ({ firstName, lastName, middleName }: GetNameProps): string => [lastName, firstName, middleName].filter((p) => (typeof p === 'string' ? p.trim() !== '' : false)).map((p) => p && p.trim()).join(' ');
